import { api } from '../api';
import { IdUser, IdCompany } from '../../contexts/auth';
import moment from 'moment';

export async function getUserConfig(usuario_id) {
    try {
        const { data } = await api.get(
            `/user-config?usuario_id=${usuario_id}&empresa_id=${IdCompany()}
        `)
        return data;
    }
    catch (error) {
        return false;
    }

};
export async function getStatusUser(usuario_id, empresa_id) {
    try {
        const { data: { status } } = await api.get(`/user-config?usuario_id=${usuario_id}&empresa_id=${empresa_id}`)
        return status;
    }
    catch (error) {
        return false;
    }
};
export async function postStatusUser(usuario_id, empresa_id, status) {
    let body = {
        usuario_id,
        empresa_id,
        status
    };
    try {
        const data = await api.post(`/user-config`, body)
        return data;
    }
    catch (error) {
        return false;
    }
};
export async function putStatusUser(status) {
    let body = {
        usuario_id: IdUser(),
        empresa_id: IdCompany(),
        status,
        status_at: moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
    };
    try {
        const { data } = await api.put(`/user-config`, body)
        return data;
    }
    catch (error) {
        return false;
    }
};
export async function maxAttendances(usuario_id, maxAttendances) {
    let body = {
        usuario_id,
        empresa_id: IdCompany(),
        max_atendimentos: maxAttendances
    };
    try {
        const { data } = await api.put(`/user-config`, body)
        return data;
    }
    catch (error) {
        return false;
    }
};